// Encontra a packing list de um pedido: a etiqueta de retirada (label_type 'Pickup')
// que esta VALID e tem o PDF da packing list anexado (label_file.path).
// Retorna a etiqueta, ou null quando nao ha packing list disponivel.
export const findPackingListLabel = (shippingLabels = []) =>
  shippingLabels.find(
    (label) =>
      label.label_type === 'Pickup' &&
      label.status === 'VALID' &&
      label.label_file?.path
  ) || null
